import NodeRSA from 'node-rsa'

const DEFAULT_PUBLIC_KEY = new NodeRSA(`-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAiv4Y+xMq6pVNhTz4VUQY
qnkt/2Bj19NDMPHutxkYqTioQ2VrjWm/bPGAEdxnJrqGf8xJfONDmbSW9REdLEct
x7r//MIZsuc07MgNdQ+8i0eEivEU+ano6IUAe33RmWkw6vkhDJ7TeP8nXTnxgeli
XYtn/2ynxw2AefEo8+fN9Pb1kCjlt23ICwPusX3C1E/ofzFDLsCiN+UR9GWecIMD
LG2zFYqWCu5lEk8VGUmmJUMe5gctmPYnkKzbGQvmLuWBpiDS3yc42w3EYso033d4
BT5t9fshUTanDnwLhIcwkzAm6hn3+wB1r+vsZfowCFqbhKyTRXV0+KdfoI46U7SB
fwIDAQAB
-----END PUBLIC KEY-----`);

export function encrypt(text, key) {
    if (!key) {
        key = DEFAULT_PUBLIC_KEY
    }
    return key.encrypt(text, 'base64')
}

export function decrypt(text, key) {
    if (!key) {
        key = DEFAULT_PUBLIC_KEY
    }
    return key.decrypt(text, 'utf8')
}

export default {
    encrypt,
    decrypt,
}
